let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];
class TrackingService {
  constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.SessionService = SessionService;
  }

  getOrderById(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getOrder,
        cache: false,
        data: this.$httpParamSerializerJQLike(data),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(response => {
        resolve(response.data);
      }).catch(reason => {
        reject(reason);
      });
    });
  }


  tracking(orderId) {
    return this.$q((resolve, reject) => {
      this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getTracking + "?id="+orderId,
          cache: true
      }).then((response) => {
          resolve(response.data);
      }, (reason) => {
          reject(reason);
      });
  });
  }



}

TrackingService.$inject = inject;

export default TrackingService;



// WEBPACK FOOTER //
// ./www/components/orders/tracking/tracking.service.js